import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./BannerSlider.css"; // Custom styles
import { apiGet } from "../../../API/Service/apiClient";
import { getImageUrl } from "../../../MIS/Global";

// Custom Next Arrow
const NextArrow = ({ onClick }) => (
  <div className="custom-arrow next-arrow" onClick={onClick}>
    <FaArrowRight />
  </div>
);

// Custom Prev Arrow
const PrevArrow = ({ onClick }) => (
  <div className="custom-arrow prev-arrow" onClick={onClick}>
    <FaArrowLeft />
  </div>
);

const BannerSlider = () => {
  const [images, setImages] = useState([]);
  const [listLoading, setListLoading] = useState(false);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          dots: true,
        },
      },
    ],
  };

  const isValidUrl = (url) => {
    try {
      new URL(url);
      return true;
    } catch (e) {
      return false;
    }
  };

  const handleGet_data = async () => {
    setListLoading(true);
    const data = { limit: 100, page: 1 };
    try {
      const resData = await apiGet("banners", data);
      setImages(resData?.data || []);
    } catch (error) {
      console.error("Something went wrong! Please try again", error);
    } finally {
      setListLoading(false);
    }
  };

  useEffect(() => {
    handleGet_data();
  }, []);

  const handleImageClick = (img) => {
    const url = img?.redirect_path;
    if (isValidUrl(url)) {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div className="carousel-container">
      {listLoading ? (
        <div className="d-flex justify-content-center align-items-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <>
          {images?.length <=1 ?
          (
            <>            
            {images?.map((img, index) => (
            <div key={index} onClick={() => handleImageClick(img)} style={{ cursor: "pointer" }}>
              <img
                src={getImageUrl(`${img?.imgpath}`)}
                alt={`Slide ${index + 1}`}
                className="carousel-image"
              />
            </div>
           ))}        
          </>
          )
          :(
            <>
            <Slider {...settings}>
            {images?.map((img, index) => (
              <div key={index} onClick={() => handleImageClick(img)} style={{ cursor: "pointer" }}>
                <img
                  src={getImageUrl(`${img?.imgpath}`)}
                  alt={`Slide ${index + 1}`}
                  className="carousel-image"
                />
              </div>
             ))}
            </Slider>
          </>
          )
          }
        </>
        
      )}
    </div>
  );
};

export default BannerSlider;
